module.exports = __webpack_public_path__ + "static/media/pgaMemberLogo300x308.5a98bc46.png";